import React from 'react';
import PropTypes from 'prop-types';
import { Disclosure } from '@headlessui/react';
import classNames from 'classnames';
import ChevronDownIcon from 'components/v2/icons/ChevronDownIcon';
import ChevronRightIcon from 'components/v2/icons/ChevronRightIcon';
export default function CollapsibleItem({ text, renderTitle, className, children, defaultOpen, disclosureButtonClassName, hideIcon, dataTestId }) {
    return ((React.createElement(Disclosure, { defaultOpen: defaultOpen }, ({ open }) => (React.createElement("div", { "data-testid": dataTestId, className: classNames(className) },
        React.createElement(Disclosure.Button, { "data-testid": "undefined-a59a528d", className: classNames('flex items-center justify-between w-full', disclosureButtonClassName) },
            text && (React.createElement("span", { "data-testid": "span-e694070c", className: "text-sm text-gray-700 font-medium" }, text)),
            renderTitle && renderTitle(open),
            open && !hideIcon && React.createElement(ChevronDownIcon, { className: "w-4 h-4" }),
            !open && !hideIcon && React.createElement(ChevronRightIcon, { className: "w-4 h-4" })),
        React.createElement(Disclosure.Panel, { "data-testid": "undefined-06e368ff" }, children))))));
}
CollapsibleItem.propTypes = {
    text: PropTypes.string,
    renderTitle: PropTypes.func,
    defaultOpen: PropTypes.bool,
    hideIcon: PropTypes.bool,
};
CollapsibleItem.defaultProps = {
    defaultOpen: false,
    hideIcon: false,
};
